// extracted by mini-css-extract-plugin
export default {"container":"currentdaytotaltime_container__oP0yH","title":"currentdaytotaltime_title__0LyEQ","text":"currentdaytotaltime_text__f32bI","time":"currentdaytotaltime_time__d2Be7"};